// import { Redirect } from "react-router-dom"
import { all, call, fork, put, takeEvery } from "redux-saga/effects"
import { getCategoriesApi } from "../../services/Api/CategoryApi"
import { getCategoryList, getErrors } from "../reducers/CategoryReducer"

// Watchers
function* categoryListSaga() {
	yield takeEvery("category_list/getCategories", getAllCategories)
}

// Sagas
function* getAllCategories(action) {
	// console.log(action)
	try {
		const getCategories = yield call(getCategoriesApi, action.payload)
		// console.log(getCategories,"ldfgsdgb")

		if (getCategories.request.status === 200) {
			yield put(getCategoryList(getCategories))
		} else {
			yield put(getErrors(true))
		}
	} catch (error) {
		// console.log(error,"otp error")
		yield put(getErrors(error))
	}
}

export default function* rootSaga() {
	yield all([fork(categoryListSaga)])
}
